// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Float from "rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as ReactFeather from "react-feather";
import * as Numeral$Coronate from "./Externals/Numeral.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import LogoSvg from "../graphics/logo.svg";
import BmcButtonSvg from "../graphics/bmc-button.svg";

function ascend(cmp, getter, a, b) {
  return cmp(getter(a), getter(b));
}

function descend(cmp, getter, a, b) {
  return cmp(getter(b), getter(a));
}

function swap(arr, idx1, idx2) {
  var match = Belt_Array.get(arr, idx1);
  var match$1 = Belt_Array.get(arr, idx2);
  if (match !== undefined && match$1 !== undefined) {
    arr[idx1] = Caml_option.valFromOption(match$1);
    arr[idx2] = Caml_option.valFromOption(match);
    return arr;
  } else {
    return arr;
  }
}

var $$Array = {
  swap: swap
};

var logo = LogoSvg;

var buyMeACoffee = BmcButtonSvg;

var WebpackAssets = {
  logo: logo,
  buyMeACoffee: buyMeACoffee
};

var formatter = new (Intl.DateTimeFormat)(["en-US"], {
      day: "2-digit",
      month: "short",
      year: "numeric"
    });

function Utils$DateFormat(props) {
  var date = props.date;
  return JsxRuntime.jsx("time", {
              children: formatter.format(date),
              dateTime: date.toISOString()
            });
}

var formatter$1 = new (Intl.DateTimeFormat)(["en-US"], {
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      month: "short",
      year: "numeric"
    });

function Utils$DateTimeFormat(props) {
  var timeZone = props.timeZone;
  var date = props.date;
  var formatter$2 = timeZone !== undefined ? new (Intl.DateTimeFormat)(["en-US"], {
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          month: "short",
          timeZone: timeZone,
          year: "numeric"
        }) : formatter$1;
  return JsxRuntime.jsx("time", {
              children: formatter$2.format(date),
              dateTime: date.toISOString()
            });
}

function Utils$Panel(props) {
  var __style = props.style;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var style = __style !== undefined ? __style : ({});
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: "utils__panel " + className,
              style: style
            });
}

var Panel = {
  make: Utils$Panel
};

function Utils$PanelContainer(props) {
  var __style = props.style;
  var __className = props.className;
  var className = __className !== undefined ? __className : "";
  var style = __style !== undefined ? __style : ({});
  return JsxRuntime.jsx("div", {
              children: props.children,
              className: "utils__panels " + className,
              style: style
            });
}

var PanelContainer = {
  make: Utils$PanelContainer
};

function Utils$Notification(props) {
  var __style = props.style;
  var __className = props.className;
  var __tooltip = props.tooltip;
  var __kind = props.kind;
  var kind = __kind !== undefined ? __kind : "Generic";
  var tooltip = __tooltip !== undefined ? __tooltip : "";
  var className = __className !== undefined ? __className : "";
  var style = __style !== undefined ? __style : ({});
  var match;
  switch (kind) {
    case "Success" :
        match = [
          JsxRuntime.jsx(ReactFeather.Check, {}),
          "utils__notification-success"
        ];
        break;
    case "Warning" :
        match = [
          JsxRuntime.jsx(ReactFeather.AlertTriangle, {}),
          "utils__notification-warning"
        ];
        break;
    case "Error" :
        match = [
          JsxRuntime.jsx(ReactFeather.AlertTriangle, {}),
          "utils__notification-error"
        ];
        break;
    case "Generic" :
        match = [
          JsxRuntime.jsx(ReactFeather.Info, {}),
          ""
        ];
        break;
    
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: match[0],
                      "aria-label": tooltip,
                      className: "utils__notification-icon",
                      title: tooltip
                    }),
                JsxRuntime.jsx("div", {
                      children: props.children,
                      className: "utils__notification-text"
                    })
              ],
              className: "utils__notification-container " + match[1] + " " + className,
              style: style
            });
}

var $$Notification = {
  make: Utils$Notification
};

function Utils$TestId(props) {
  return React.cloneElement(props.children, {
              "data-testid": props.testId
            });
}

var TestId = {
  make: Utils$TestId
};

function validateFieldOnBlurWithValidator(input, fieldStatus, validator) {
  if (typeof fieldStatus !== "object") {
    return {
            TAG: "Dirty",
            _0: validator(input)
          };
  }
  
}

function exposeFieldResult(fieldStatus) {
  if (typeof fieldStatus !== "object") {
    return ;
  } else {
    return fieldStatus._0;
  }
}

var FormHelper = {
  validateFieldOnBlurWithValidator: validateFieldOnBlurWithValidator,
  exposeFieldResult: exposeFieldResult
};

Numeral$Coronate.registerFormat("fraction", Numeral$Coronate.Format.make(Numeral$Coronate.RegExps.make(/(1\/2)/, /(1\/2)/), (function (value, _format, _roundingFunction) {
            var whole = Math.floor(value);
            var remainder = value - whole;
            var fraction = remainder !== 0.25 ? (
                remainder !== 0.5 ? (
                    remainder !== 0.75 ? "" : "¾"
                  ) : "½"
              ) : "¼";
            var stringedWhole = whole === 0.0 && fraction !== "" ? "" : String(whole);
            return stringedWhole + fraction;
          }), (function (value) {
            return Belt_Option.getWithDefault(Belt_Float.fromString(value), 0.0);
          })));

var github_url = "https://github.com/johnridesabike/coronate";

var license_url = "https://github.com/johnridesabike/coronate/blob/master/LICENSE";

var issues_url = "https://github.com/johnridesabike/coronate/issues/new";

var changelog_url = "https://github.com/johnridesabike/coronate/blob/master/CHANGELOG.md";

var faq_url = "https://github.com/johnridesabike/coronate/blob/master/docs/faq.md";

var DateFormat = {
  make: Utils$DateFormat
};

var DateTimeFormat = {
  make: Utils$DateTimeFormat
};

export {
  github_url ,
  license_url ,
  issues_url ,
  changelog_url ,
  faq_url ,
  ascend ,
  descend ,
  $$Array ,
  WebpackAssets ,
  DateFormat ,
  DateTimeFormat ,
  Panel ,
  PanelContainer ,
  $$Notification ,
  TestId ,
  FormHelper ,
}
/* logo Not a pure module */
